module.exports = __webpack_public_path__ + "b-48.png";